import React from 'react'
import Translation from '../../../../Translation/cont/Translation'

const RejectedFilesList= ({files, transId}) => {
    const listItems = files.map((fileData, index) => {
        const {file, errors} = fileData
        return (
        <li key={index}>
            <p>{file.name}</p>
            {errors.map((error,index) => (
                <p key={index}>{error.message}</p>
            ))}
        </li>
    )})

    return (
        <div>
            <p><Translation id={transId}/></p>
            <ul>{listItems}</ul>
        </div>
    )
}

export default RejectedFilesList